<template>
  <nav class="bg-gradient-to-r from-lobster-600 via-amber-500 to-amber-600 z-50 shadow-sm sticky top-14 border-y">
    <div class="header-layout">
      <div class="flex justify-between items-center h-11">
        <div class="flex overflow-x-auto hide-scrollbar">
          <div class="flex space-x-4 sm:space-x-8 items-center">
            <button v-for="tab in tabs" :key="tab.name" @click="changeTab(tab.name)" :class="[
                currentTab === tab.name
                  ? 'text-white'
                  : 'text-white/80 hover:text-white',
                'inline-flex items-center text-xs font-medium whitespace-nowrap'
              ]">
              {{ tab.label }}
            </button>
          </div>
        </div>
        <div :class="[rightContentClass, additionalRightContentClass]">
          <slot name="right-content"></slot>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  initialTab: {
    type: String,
    default: 'general',
  },
  rightContentClass: {
    type: String,
    default: 'flex items-center ml-4 sm:ml-6',
  },
  additionalRightContentClass: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['change-tab'])

const route = useRoute()
const router = useRouter()

const currentTab = ref(props.initialTab)

// Helper function to preserve all query parameters
const preserveQueryParams = (newTab) => {
  const currentQuery = { ...route.query }
  return {
    ...currentQuery,
    tab: newTab,
  }
}

const changeTab = (tabName) => {
  // Eğer zaten seçili tab'daysa işlem yapma
  if (currentTab.value === tabName) {
    return
  }
  
  // Yerel state'i güncelle
  currentTab.value = tabName
  
  // Tek bir URL güncellemesi yap
  // Bu şekilde route değişimini önceden gerçekleştirerek parent'in hazır olmasını sağlarız
  router.replace({ query: { tab: tabName } }).then(() => {
    // Router güncellendikten sonra parent'a bildir
    // Bu sıralama önemli, önce route sonra emit
    emit('change-tab', tabName)
  }).catch(err => {
    console.error('Tab navigation routing error:', err)
    // Hata olsa bile emit yapalım
    emit('change-tab', tabName)
  })
}

// Check initial tab value on mount and update if needed
onMounted(() => {
  // If URL contains a valid tab, use it
  if (route.query.tab && props.tabs.some(tab => tab.name === route.query.tab)) {
    currentTab.value = route.query.tab
    // Notify parent component of initial tab - this is the key fix!
    emit('change-tab', currentTab.value)
  } else if (props.initialTab && props.tabs.some(tab => tab.name === props.initialTab)) {
    // Otherwise use initialTab
    currentTab.value = props.initialTab
    // Notify parent component of initial tab - this is the key fix!
    emit('change-tab', currentTab.value)
  }
})

// Watch for URL tab changes
watch(() => route.query.tab, (newTab) => {
  if (newTab && props.tabs.some(tab => tab.name === newTab) && currentTab.value !== newTab) {
    currentTab.value = newTab
    // Also notify parent component
    emit('change-tab', newTab)
  }
})
</script>

<style scoped>
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>